export default __webpack_public_path__ + "static/howFWAWorksStep4-aa140427eaf4d5c7d23b96d6cd812d95.png";